<template>
    <div>

        <!-- 默认页面 -->
        <div v-show="!is_sort">
            <el-row style="text-align: right;">
                <el-button
                    style="background-color: #006E4B; color: #FFFFFF; border: 1px #006E4B solid; font-size: 17px; padding: 10px 20px;"
                    @click="AddDepartmentFrom">
                    添加子部门</el-button>
                <el-button
                    style="background-color: #006E4B; color: #FFFFFF; border: 1px #006E4B solid; font-size: 17px; padding: 10px 20px; width: 127px;"
                    @click="DepartmentSort">
                    排序</el-button>
            </el-row>

            <!-- 默认 -->
            <el-row style="margin-top: 10px;">
                <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                    :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    style="width: 100%;" height="520" @selection-change="handleSelectionChange">
                    <el-table-column align="center" label="序号" width="200">
                        <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                    </el-table-column>
                    <el-table-column prop="project_name" align="center" label="部门名称">
                        <template slot-scope="scope">
                            {{condition.flag == 'plate' ? scope.row.project_name : scope.row.organize_name}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="organize_number" align="center" label="部门人数"></el-table-column>
                </el-table>

                <!-- 分页 -->
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </el-row>
        </div>

        <!-- 部门排序页面 -->
        <div v-show="is_sort">
            <sort ref="sort" @Return="sortReturn"></sort>
        </div>

        <!-- 添加部门弹出层 -->
        <el-dialog center :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
            <template slot="title"><span style="font-weight: bold;">添加部门</span></template>
            <el-form :model="from" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="部门名称" prop="project_name">
                    <el-input v-model="from.project_name" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="部门主管" prop="staff_ids">
                    <div @click="setStaff">
                        <el-input v-model="from.staff_name" placeholder="点击设置部门主管" onfocus="this.blur();"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="上级部门">
                    <el-input v-model="from.organize_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label-width="0" style="text-align: center;">
                    <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 100px;"
                        @click="AddDepartment">保存</el-button>
                </el-form-item>
            </el-form>

            <!-- 部门主管弹出层 -->
            <el-dialog width="40%" center :visible.sync="setStaffVisible" append-to-body :close-on-click-modal="false"
                :show-close="false">
                <template slot="title"><span style="font-weight: bold;">设置部门主管</span></template>
				<el-row style="border:1px solid #EBEEF5;">
					<setStaff ref="setStaff" type="checkbox" :accordion="false" @commit="saveChange" :staff_ids_prop="from.staff_ids">
					</setStaff>
				</el-row>
				<el-row style="text-align: center;">
					<el-button type="goon" style="margin-top: 10px;" @click="$refs['setStaff'].commit()">确定</el-button>
				</el-row>
            </el-dialog>

        </el-dialog>
    </div>
</template>

<script>
    import sort from './Jtzzjggl_department_sort.vue';
    import setStaff from '../../utils/organizeStaff/organizeStaff.vue';

    export default {
        components: {
            sort: sort,
            setStaff: setStaff,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,
                is_sort: false,
                setStaffVisible: false,
                setDepartmentVisible: false,

                //条件
                condition: {
                    //部门id
                    project_id: "",
                    //标识
                    flag: ""
                },

                //表单数据
                from: {
                    project_name: "",
                    staff_ids: [],
                    staff_name: "",
                    organize_id: "",
                    organize_name: "",
                },

                //表单验证
                rules: {
                    project_name: [{
                        required: true,
                        message: '请输入部门名称！',
                        trigger: 'blur'
                    }],
                    // staff_ids: [{
                    //     required: true,
                    //     message: '请选择部门主管！',
                    //     trigger: 'blur'
                    // }],
                },
                
            }
        },
        methods: {
            //查询
            async Find() {
                var url = "organize/find",
                    record = {
                        page_num: this.page_num,
                        page_size: this.page_size,
                        organize_id: this.condition.project_id,
                        spare8: this.condition.flag,
                    };

                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.warning('请求失败！请稍后重试');
                    }
                }

                //刷新排序页面
                this.$refs["sort"].condition = this.condition;
                this.$refs["sort"].Find();
            },
            //分页
            handleCurrentChange(val) {
                this.page_num = val;
                this.Find();
            },
            //添加部门表单
            AddDepartmentFrom() {
                this.dialogVisible = true;
            },
            //添加部门操作
            AddDepartment() {
                this.$refs["ruleForm"].validate(async (valid) => {
                    if (valid) {

                        var staff_ids = "";
                        this.from.staff_ids.forEach(item => {
                            staff_ids += item + ',';
                        })

                        var url = "organize/insert",
                            record = {
                                organize_name: this.from.project_name,
                                organize_id: this.from.organize_id,
                                staff_ids: staff_ids,
                            };

                        var data = await this.$globals.AxiosPost(url, record);
                        if (data === '-2000') {
                            this.$message.error('服务器未响应！请稍后重试');
                        } else {
                            var code = data.code;
                            var data = data.data;
                            if (code === '200') {
                                this.$message.success(data);
                                this.dialogVisible = false;
                                this.trash();
                                this.Find();
                                //刷新结构页面
                                this.$emit("structureFind");
                            } else {
                                this.$message.warning(data);
                            }
                        }

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //部门排序页面
            DepartmentSort() {
                this.$refs["sort"].condition = this.condition;
                this.$refs["sort"].Find();
                this.is_sort = true;
            },
            //设置部门主管页面
            setStaff() {
                this.setStaffVisible = true;
            },
            //设置确定
            saveChange(e) {
				this.from.staff_ids = e.staff_ids;
				this.from.staff_name = e.staff_name;
				this.setStaffVisible = false;
            },
            //清除数据
            trash() {
                this.from.project_name = "";
                this.from.staff_ids = [];
                this.from.staff_name = "";
                this.from.organize_id = this.condition.project_id;
                this.from.organize_name = this.condition.project_name;
            },
            sortReturn(){
                this.is_sort = false;
                this.Find();
                //刷新结构页面
                this.$emit("structureFind");
            }
        },
        created() {
        }
    }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// Jtzzjggl_department.vue?121edc76